import { render, staticRenderFns } from "./SubscriptionInfo.vue?vue&type=template&id=63c403b0&scoped=true&"
import script from "./SubscriptionInfo.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionInfo.vue?vue&type=style&index=0&id=63c403b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c403b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
